import { GlobalResponseObject } from "../../../../common/index";
import { RoleContactsModel } from "./role-contacts.model";

export class RoleContactResponse extends GlobalResponseObject {
    data?: RoleContactsModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: RoleContactsModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}